<script setup lang="ts">

</script>

<template>
  <div class="grid grid-cols-[1fr_5fr_1fr] w-full items-center justify-between text-center visible lg:visible">
    <div>
      <slot name="left" />
    </div>
    <div>
      <slot name="center" />
    </div>
    <div class="flex justify-end"> 
      <slot name="right" />
    </div>
  </div>
</template>
